import React from 'react';
import cls from 'classnames';
export default function Hint(_a) {
    var hint = _a.hint, children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.position, position = _c === void 0 ? 'top' : _c, _d = _a.width, width = _d === void 0 ? null : _d, style = _a.style;
    return (React.createElement("span", { "aria-label": hint, style: style, "data-hint-width": width, className: cls("hint--".concat(size), "hint--".concat(position)) }, children));
}
